import type { ReactElement } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface LoadingHeatmapProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingHeatmap = ({
  className,
  baseContainerClasses,
}: LoadingHeatmapProps): ReactElement => {
  const rows = 7; // Days of the week
  const cols = 6; // Time slots or categories

  return (
    <div className={classNames(baseContainerClasses, "gap-4", className)}>
      {/* Title skeleton */}
      <div className="bg-tertiary h-6 w-1/2 animate-pulse rounded-full" />

      {/* Chart area */}
      <div className="flex h-96 gap-4">
        {/* Y-axis labels */}
        <div className="flex flex-col justify-between py-8">
          {Array.from({ length: rows }, (_, index) => (
            <div
              key={`y-label-${index}`}
              className="bg-tertiary h-4 w-12 animate-pulse rounded-full"
            />
          ))}
        </div>

        {/* Heatmap grid */}
        <div className="flex flex-1 flex-col gap-2">
          <div className="flex flex-1 flex-col justify-between gap-2">
            {Array.from({ length: rows }, (_, rowIndex) => (
              <div key={`row-${rowIndex}`} className="flex flex-1 gap-2">
                {Array.from({ length: cols }, (_, colIndex) => (
                  <div
                    key={`cell-${rowIndex}-${colIndex}`}
                    className={classNames(
                      "bg-tertiary flex-1 animate-pulse rounded",
                      // Add varying opacity to simulate heatmap intensity
                      (rowIndex + colIndex) % 3 === 0
                        ? "opacity-100"
                        : (rowIndex + colIndex) % 2 === 0
                          ? "opacity-60"
                          : "opacity-30",
                    )}
                  />
                ))}
              </div>
            ))}
          </div>

          {/* X-axis labels */}
          <div className="flex justify-between gap-2 pt-2">
            {Array.from({ length: cols }, (_, index) => (
              <div
                key={`x-label-${index}`}
                className="bg-tertiary h-4 flex-1 animate-pulse rounded-full"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
